if (!customElements.get('slideshow-siwper')) {
  class slideshowSwiper extends HTMLElement {
    mySwiper;
    constructor() {
      super();

    }
    connectedCallback() {
      this.style.display = "block"
      this.mySwiper = new Swiper(this.querySelector('.slideshow'), {
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoplay: this.getAttribute('data-autoplay') ? {
          delay: this.getAttribute('data-speed'),
          stopOnLastSlide: false,
          disableOnInteraction: true,
        } : false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        allowSlideNext: true,
        allowSlidePrev: true,
        navigation: {
          nextEl: this.querySelector(`.swiper-btn-next`),
          prevEl: this.querySelector(`.swiper-btn-prev`),
        },
        pagination: {
          el: this.querySelector(`.swiper-pagination`),
          clickable: true,
        },
        on: {
          slideChange: this.handleSlideChange.bind(this),
        },
        scrollbar: {
          el: this.querySelector(`.swiper-scrollbar`),
        },
      });
      this.initEvent(this.mySwiper);
    }

    /**
     * 轮播图切换事件
     */
    handleSlideChange(swiper) {

    }

    initEvent(swiper) {

    }

  }
  customElements.define('slideshow-siwper', slideshowSwiper);
}
